module.exports = __webpack_public_path__ + "img/Nora-start_spinner.1da3c0.svg";